import React from 'react';
import ModernHeader from '../components/modern/ModernHeader';
import ModernFooter from '../components/modern/ModernFooter';
import SEO from '../components/modern/SEO';

export default function Palyazat() {
  return (
    <>
      <SEO 
        title="Pályázati információ | XL Bútor Kisvárda"
        description="GINOP_PLUSZ-1.2.4-25-2025-02162 - Kapacitásbővítés a XL Bútor, Szőnyeg, Lakásberendező Kft-nél. EU támogatással megvalósuló fejlesztés."
        keywords="pályázat, EU támogatás, GINOP, kapacitásbővítés, XL Bútor"
      />
      
      <div className="bg-[var(--color-bg)] min-h-screen">
        <ModernHeader />
        
        <main>
          {/* Hero Section */}
          <section className="relative bg-gradient-to-br from-blue-900 to-blue-800 py-12 md:py-20">
            <div className="absolute inset-0 bg-black/20"></div>
            <div className="container mx-auto px-4 relative z-10">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
                  Pályázati információ
                </h1>
                <p className="text-base md:text-xl text-blue-100">
                  Európai Uniós támogatással megvalósuló fejlesztés
                </p>
              </div>
            </div>
          </section>

          {/* Content Section */}
          <section className="py-8 md:py-16 bg-white">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto">
                
                {/* Project Details */}
                <div className="bg-gray-50 rounded-xl md:rounded-2xl p-4 md:p-8 lg:p-12 shadow-lg mb-8 md:mb-12">
                  <div className="space-y-8">
                    
                    <div className="border-b border-gray-200 pb-6">
                      <h3 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        Kedvezményezett neve
                      </h3>
                      <p className="text-xl md:text-2xl font-bold text-gray-900">
                        XL Bútor, Szőnyeg, Lakásberendező Korlátolt Felelősségű Társaság
                      </p>
                    </div>

                    <div className="border-b border-gray-200 pb-6">
                      <h3 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        A projekt azonosító száma
                      </h3>
                      <p className="text-xl font-bold text-gray-900">
                        GINOP_PLUSZ-1.2.4-25-2025-02162
                      </p>
                    </div>

                    <div className="border-b border-gray-200 pb-6">
                      <h3 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        A fejlesztés tárgya, célja
                      </h3>
                      <p className="text-xl font-bold text-gray-900">
                        Kapacitásbővítés a XL Bútor, Szőnyeg, Lakásberendező Kft-nél
                      </p>
                    </div>

                    <div className="border-b border-gray-200 pb-4 md:pb-6">
                      <h3 className="text-xs md:text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        Szerződött támogatás összege
                      </h3>
                      <p className="text-2xl md:text-3xl font-bold text-green-600">
                        23 093 503 Ft
                      </p>
                    </div>

                    <div className="border-b border-gray-200 pb-4 md:pb-6">
                      <h3 className="text-xs md:text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        Projekt tartalmának részletes bemutatása
                      </h3>
                      <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                        A projekt során a Társaság egy kapacitásbővítő beruházást tervez megvalósítani annak érdekében, 
                        hogy az elmúlt években produkált növekedési üteme fenntartható legyen. Továbbá olyan szoftverek 
                        is beszerzésre kerülnek, amelyekkel az értékesítési tevékenység hatékonyabbá tehető. A beruházás 
                        kulcseleme egy körfűrész, egy élfóliázó gép és a hozzájuk kapcsolódó elszívó berendezés. 
                        A fejlesztés megvalósításával a Társaság célja, hogy hatékonyabbá és átláthatóvá váljon a működése.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-2">
                        A projekt tervezett befejezési dátuma
                      </h3>
                      <p className="text-xl font-bold text-gray-900">
                        2027.08.17.
                      </p>
                    </div>

                  </div>
                </div>

                {/* EU Funding Notice */}
                <div className="bg-blue-50 border-l-4 border-blue-600 p-4 md:p-6 rounded-r-lg mb-8 md:mb-12">
                  <p className="text-blue-900 text-base md:text-lg font-medium">
                    A projekt az Európai Unió támogatásával, a magyar állam társfinanszírozásával valósult meg.
                  </p>
                </div>

                {/* Logo Banner */}
                <div className="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 md:p-8 border border-gray-100">
                  <img 
                    src="/images/Weboldalképei/kedvezmenyezetti-infoblokk-keretes.jpg" 
                    alt="Széchenyi Terv Plusz - Magyarország Kormánya - Európai Unió" 
                    className="w-full h-auto max-w-3xl mx-auto"
                  />
                </div>

              </div>
            </div>
          </section>
        </main>

        <ModernFooter />
      </div>
    </>
  );
}
